module.exports = __webpack_public_path__ + "static/img/Emily-Van-Egmond.b1329a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Emily-Van-Egmond.jpg
// module id = L7a/
// module chunks = 0